import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterConstants } from "../../../../../redux/constants";
import CustomCheckBox from "../../../../customCheckBox";
import { useTranslation } from "react-i18next";
const { POLAROID } = filterConstants;

const PolaroidFilter = ({ applyFilter, fabric }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _filter = useSelector((state) => state.filter);
  const applyPolaroid = (check) => {
    dispatch({
      type: POLAROID,
      payload: check,
    });
    applyFilter(15, check && new fabric.Image.filters.Polaroid());
  };
  return (
    <div>
      <CustomCheckBox
        lable={t("PolaroidFilter.Polaroid")}
        checked={_filter.polaroid}
        onClick={(e) => applyPolaroid(e.target.checked)}
      />
    </div>
  );
};

export default PolaroidFilter;
